import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-17696396")
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({
    navigationmeta:true,
  })
}
const _hoisted_2 = {
  key: 0,
  class: "subnav"
}
const _hoisted_3 = {
  key: 1,
  class: "subnav"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.path.includes('/developer'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "row",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routeTo('/app/')))
          }, "Browse"),
          _createElementVNode("div", {
            class: "row",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routeTo('/')))
          }, "Root"),
          _createElementVNode("div", {
            class: "row",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routeTo('/policy')))
          }, "Terms"),
          _createElementVNode("div", {
            class: "row",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routeTo('/policy')))
          }, "Policies")
        ]))
      : (!_ctx.$route.path.includes('/developer'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.routeTo('/')))
            }, "Home"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.routeTo('/developer/games')))
            }, "Develop"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.routeTo('/policy')))
            }, "Policies"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.routeTo('/policy/terms')))
            }, "Terms"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.routeTo('/policy/privacy')))
            }, "Privacy"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.routeTo('/policy/cookie')))
            }, "Cookies"),
            _createElementVNode("div", {
              class: "row",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.routeTo('/policy/pwa')))
            }, "PWA")
          ]))
        : _createCommentVNode("", true)
  ]))
}